module.exports = __webpack_public_path__ + "img/12.a34eafae.png";